// Layouts
import EmptyBody from "@/Layouts/components/Basics/EmptyBody";
import RoundedBox from "@/Layouts/components/Basics/RoundedBox";

// Interfaces/Types
import { IWashoutData } from "@/Washouts/types/WashoutReview";

type TEmptySectionProps = {
	washoutData?: IWashoutData;
	image: string;
	title: string;
};

const EmptySection = (props: TEmptySectionProps) => {
	const { washoutData, image, title } = props;
	return (
		<>
			{!washoutData && (
				<RoundedBox>
					<EmptyBody
						image={image}
						title={title}
						bodyHeight={"510px"}
						sx={{
							boxShadow: "none !important",
						}}
					/>
				</RoundedBox>
			)}
		</>
	);
};

export default EmptySection;
